<template>
  <div class="site-search-bar">
    <div class="site-search-bar-container">
      <input
        id="site-search-bar-input"
        v-model="searchValue"
        class="input-site-search-bar"
        :class="searchValue.length < 3 ? 'txt-color-grey' : 'txt-color-black'"
        type="text"
        name="search"
        placeholder="Search PBC"
        @keyup.enter="searchBarSearch()"
      >
      <button
        id="site-search-bar-button"
        class="btn btn-link btn-site-search-bar btn-site-search-bar-submit"
        aria-label="Search"
        @click.prevent="searchBarSearch()"
      >
        <i
          class="fa fa-search"
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
</template>
<script>
import { useSiteSearchBarStore } from '../../stores/SiteSearchBarStore';

export default {
  name: 'SiteSearchBar',
  data() {
    return {
      store: useSiteSearchBarStore(),
      searchValue: '',
    };
  },
  mounted() {},
  methods: {
    searchBarSearch() {
      if (this.searchValue.length >= 3) {
        this.store.setSiteSearch(this.searchValue);
        this.store.setSearchSubmitted(true);
      }
    },
  },
};
</script>
